import { methodNotFoundError, invalidParamsError } from './JsonRpcError';
import { jsonRpcFailure } from './JsonRpcRequest';
import type { JsonRpcRequest, JsonRpcResult } from './JsonRpcRequest';

export class RequestModelingRequest {
  static readonly METHOD = 'request_modeling';

  private constructor(
    private readonly _requestId: string,
    private readonly _viewModelId: string,
    private readonly _instruction: string
  ) {}

  get requestId(): string {
    return this._requestId;
  }

  get viewModelId(): string {
    return this._viewModelId;
  }

  get instruction(): string {
    return this._instruction;
  }

  static from(req: JsonRpcRequest): JsonRpcResult<RequestModelingRequest> {
    if (req.method !== RequestModelingRequest.METHOD) {
      return jsonRpcFailure(req.id, methodNotFoundError('unknown_method', `unknown method: ${req.method}`));
    }

    const params = req.params;
    const viewModelId = params['viewModelId'];
    const instruction = params['instruction'];
    if (typeof viewModelId !== 'string' || typeof instruction !== 'string') {
      return jsonRpcFailure(
        req.id,
        invalidParamsError('invalid_params_fields', `invalid params fields: ${JSON.stringify(params)}`)
      );
    }

    return { ok: true, value: new RequestModelingRequest(req.id, viewModelId, instruction) };
  }
}
